export const DIALOG_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type DialogType = (typeof DIALOG_TYPES)[keyof typeof DIALOG_TYPES];

export const TOAST_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type ToastType = (typeof TOAST_TYPES)[keyof typeof TOAST_TYPES];

export const TOAST_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;

export type ToastSize = (typeof TOAST_SIZE)[keyof typeof TOAST_SIZE];

export const TOOLTIP_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type TooltipPosition =
  (typeof TOOLTIP_POSITION)[keyof typeof TOOLTIP_POSITION];

export const ICON_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
  BOTH: 'both',
} as const;

export type IconPosition = (typeof ICON_POSITION)[keyof typeof ICON_POSITION];

export const SwipeCardStatus = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  TIMEOUT: 'timeout',
  DEACTIVATED: 'deactivated',
  READY: 'ready',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  PERMISSION_GRANTED: 'permission_granted',
  TOKEN_GENERATING: 'token_generating',
  BLUETOOTH_NOT_AVAILABLE: 'bluetooth_not_available',
  DEVICE_NOT_SUPPORTED: 'device_not_supported',
} as const;

export type SwipeCardStatus =
  (typeof SwipeCardStatus)[keyof typeof SwipeCardStatus];

export const ALERT_MESSAGE_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type AlertMessageType =
  (typeof ALERT_MESSAGE_TYPE)[keyof typeof ALERT_MESSAGE_TYPE];
